// extracted by mini-css-extract-plugin
export default {"infoIcon":"Evaluation_infoIcon__5Jv0q","container":"Evaluation_container__T9wFc","buttonsContainer":"Evaluation_buttonsContainer__ZxawD"};